import { PROPOSAL_COPY_FONT, PROPOSAL_TEXT } from "@/lib/proposalTheme";
import { sortedProposalDisclaimers, type DtoolsProposalPresentation } from "@shared/dtoolsProposalPresentation";

type Props = {
  presentation: DtoolsProposalPresentation;
};

export default function DtoolsProposalDisclaimersFooter({ presentation }: Props) {
  const disclaimers = sortedProposalDisclaimers(presentation);
  if (disclaimers.length === 0) return null;

  return (
    <section className="space-y-4 border-t border-[#1A2744]/10 pt-8" style={{ fontFamily: PROPOSAL_COPY_FONT }}>
      <h3 className="text-sm font-semibold uppercase tracking-[0.14em]" style={{ color: PROPOSAL_TEXT }}>
        Disclaimers
      </h3>
      <div className="space-y-5">
        {disclaimers.map((row) => (
          <div key={row.id} className="space-y-1.5">
            <p className="text-sm font-semibold text-[#1A2744]">{row.name}</p>
            <p className="text-sm leading-7 text-[#1A2744]/85 whitespace-pre-wrap">{row.content}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
